import { FC } from 'react';

import { HeaderMenuLogo } from '../HeaderMenu/HeaderMenuLogo';

export const HeaderBarSimple: FC = () => (
  <div className="fixed top-0 left-0 z-header w-full">
    <header className="c-se--default">
      <a href="/" className="-mb-2 block h-18 w-30">
        <HeaderMenuLogo />
      </a>
    </header>
  </div>
);
